import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAvatarBackgroundAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: null,
        price: 0,
        isPublished: false,
        isDefault: false,
        isNew: false,
        isSpecial: false,
        imageFile: null
    });

    const validations = {
        name: { required },
        price: { required, numeric },
        imageFile: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            avatarService.background.create(
                model.name,
                model.price,
                model.isPublished,
                model.isDefault,
                model.isNew,
                model.isSpecial,
                model.imageFile
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX })
    });

    return { model, v$, create };
}
